import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSelectionListChange } from '@angular/material/list';
import { GlobalStoreService } from '@principle-theorem/ng-principle-shared';
import { TrackByFunctions } from '@principle-theorem/ng-shared';
import {
  BridgeDeviceStatus,
  IBridgeDevice,
  IHicapsConnectTerminal,
  IPractice,
  IStaffer,
} from '@principle-theorem/principle-core/interfaces';
import {
  DocumentReference,
  Firestore,
  INamedDocument,
  WithRef,
} from '@principle-theorem/shared';
import { first } from 'lodash';
import { Observable } from 'rxjs';
import { ISelectedHicapsConnectTerminal } from '../selected-hicaps-connect-terminal';

export interface IHicapsSelectTerminalRequest {
  terminals: (ISelectedHicapsConnectTerminal & { isSelected?: boolean })[];
  practice: INamedDocument<IPractice>;
}

export interface IHicapsSelectTerminalResponse {
  terminal: ISelectedHicapsConnectTerminal;
}

@Component({
  selector: 'pr-hicaps-connect-select-terminal-dialog',
  templateUrl: './hicaps-connect-select-terminal-dialog.component.html',
  styleUrls: ['./hicaps-connect-select-terminal-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HicapsConnectSelectTerminalDialogComponent {
  trackByTerminal = TrackByFunctions.ref<ISelectedHicapsConnectTerminal>();

  constructor(
    private _dialogRef: MatDialogRef<
      HicapsConnectSelectTerminalDialogComponent,
      IHicapsSelectTerminalResponse
    >,
    @Inject(MAT_DIALOG_DATA) public data: IHicapsSelectTerminalRequest,
    private _globalStore: GlobalStoreService
  ) {}

  bridgeDevice$(
    terminal: IHicapsConnectTerminal
  ): Observable<WithRef<IBridgeDevice>> {
    return Firestore.doc$(terminal.bridgeDevice);
  }

  isDisabled(bridgeDevice: WithRef<IBridgeDevice>): boolean {
    return bridgeDevice.status !== BridgeDeviceStatus.Active;
  }

  selectTerminal(event: MatSelectionListChange): void {
    const terminal = first(
      event.source.selectedOptions.selected.map(
        (option) => option.value as ISelectedHicapsConnectTerminal
      )
    );
    if (!terminal) {
      return;
    }
    this._dialogRef.close({ terminal });
  }

  getStafferImage$(
    practitionerRef: DocumentReference<IStaffer>
  ): Observable<string | undefined> {
    return this._globalStore.getStafferImage$({ ref: practitionerRef });
  }

  getStafferName$(
    practitionerRef: DocumentReference<IStaffer>
  ): Observable<string> {
    return this._globalStore.getStafferName$({ ref: practitionerRef });
  }
}
